import AppState, { POPUPS } from '@/js/AppState';
import { observer } from 'mobx-react-lite';
import PopupsManager from 'react-sdk/PopupsManager';


import HaxeBackend from '@/components/HaxeBackend/HaxeBackend';
import classes from './ScreenGame.module.css';

import Characters from '@/components/Dial/Characters';
import MapButton from '@/components/Hud/MapButton/MapButton';
import OptionsBlock from '@/components/Hud/OptionsBlock/OptionsBlock';
import ObjectiveBar from '@/components/ObjectiveBar/ObjectiveBar';
import Minigames from '@/js/Minigames/Minigames';
import clsx from 'clsx';
import { pickRandom } from 'react-sdk/utils';
import GameOverlay from './GameOverlay';
import PlayerBlock from '@/components/Hud/PlayerBlock/PlayerBlock';
import Popups from '@/components/popups/Popups';
import Slides from '@/js/Slides';
import LeaderboardButton from '@/components/Hud/LeaderboardButton/LeaderboardButton';
import ScoreBar from '@/components/Hud/ScoreBar/ScoreBar';
import Ftues from '@/js/Ftues';
import SequencesManager from 'react-sdk/haxelibs/SequencesManager';

const ScreenGame = () => {


  let dialOverlayVisible = (AppState.dials && AppState.dials.currentDial)
  let popupOverlayVisible = (PopupsManager.someOpened || Minigames.current)

  // cas particulier pour les images fullscreen des dossiers, on affiche l'overlay en mode 'light' (moins opaque)
  let overlayLight = false
  if (PopupsManager.isOpened(POPUPS.IMG_FS)) {
    let data = PopupsManager.getData(POPUPS.IMG_FS)
    overlayLight = (data.imgUrl && data.imgUrl.includes("dossier"))
  }

  return (
    <div className={classes.ScreenGame}>

      <HaxeBackend visible={AppState.haxeBackendVisible}/>



      {dialOverlayVisible && <GameOverlay key={"dial-overlay"}/>}
      <Characters dials={AppState.dials} />


      {AppState.objectives.activeRootObjectives.length > 0 &&
      <div className={classes.objbar}>
        <ObjectiveBar rootObjective={AppState.objectives.activeRootObjectives[0]} />
      </div>}

      <div className={classes.scorebar}>
        <ScoreBar chapter={AppState.currentChapter} />
      </div>

      {AppState.hudVisibility && AppState.UI_visibilities.mapBtn && !dialOverlayVisible &&
      <MapButton />}

      {!AppState.leaderboardDisabled && AppState.hudVisibility && AppState.UI_visibilities.leaderboardBtn && !dialOverlayVisible &&
      <LeaderboardButton />}

      <div className={classes.player_block}>
        <PlayerBlock />
      </div>

      {AppState.debugMode &&
      <div className={classes.debug}>
        <details>
          <summary>DEBUG</summary>
          <div>
            <button onClick={() => {
              AppState.deleteSave(false)
            }}>Supprimer sauvegarde (et reload)</button>
            <button onClick={() => {
              AppState.vertxClient.GroupUserRemove(AppState.vertxClient.UserData.getUniverse(), AppState.group.groupId, AppState.vertxClient.UserData.getUserID(), (success, msg, data) => {
                      if(success)
                        AppState.deleteSave(true)
                      else
                        console.error("GroupUserRemove error : " + msg)

                    })
            }
            }>Quitter groupe (supprime également la sauvegarde et reload)</button>
            <button onClick={() => {
              PopupsManager.open(POPUPS.LEADERBOARD)
            }}>Afficher leaderboard</button>

            <details>
              <summary>les minigames</summary>
              <ol>
                {Minigames.all
                .filter(mg => !mg.line.get("parent"))
                .map(mg => (
                <li>
                  <button onClick={() => Minigames.play(mg.id, () => {})}>Play minigame {mg.id}</button>
                </li>))}
              </ol>
            </details>

            <details>
              <summary>popups "slides"</summary>
              <ol>
                {Slides.slidesIds.map(id => <li><button onClick={ () => PopupsManager.open(POPUPS.SLIDES, id)}>open slide {id}</button></li>)}
              </ol>
              <button onClick={ () => {
                Slides.all.forEach(s => s.PopupID = "test")
                PopupsManager.open(POPUPS.SLIDES, "test")
              }}>Voir toutes les slides à la suite</button>

            </details>

            <details>
              <summary>popups "FTUE"</summary>
              <ol>
                {Ftues.ftueIds.map(id => <li><button onClick={ () => PopupsManager.open(POPUPS.FTUE, id)}>open ftue {id}</button></li>)}
              </ol>
            </details>

            <details>
              <summary>dials</summary>
              <ol>
                {
                  SequencesManager.getFile("data/dials.data")
                  .sequenceIds
                  .map(s => (
                    <li>

                    <button
                    onClick={ () => AppState.dials.playSequence("data/dials.data", s)}>
                      lire {s}
                  </button>
                  </li>))
                }


              </ol>
            </details>

          </div>



        </details>
      </div>}

      {popupOverlayVisible && <GameOverlay key={"popup-overlay"} light={overlayLight}/>}

      <Popups />


      <OptionsBlock in_game={true}/>


    </div>
  );
};

export default observer(ScreenGame);
